import { createContext, useState, useContext, useMemo } from "react";
import { Praca } from "../services/PracaService";
import { getAccessTokenLocalStorage, ValidAccessTokenLocalStorage, handleUserLogOutErro } from "../context/utils"
import { UserPreferenceContext } from "../context/UserPreferenceContext";
import PropTypes from 'prop-types';
export const PracaContext = createContext();

const PracaProvider = ({ children }) => {
    const [praca, setPraca] = useState();
    const { userAuthenticated, setUserAuthenticated, setUserMenssageApi } = useContext(UserPreferenceContext);
    async function doPraca() {
        let token = getAccessTokenLocalStorage();
        if (ValidAccessTokenLocalStorage()) {
            await Praca(token
            ).then(res => {
                setPraca(res.data);
            })
                .catch(err => {
                    handleUserLogOutErro(err, userAuthenticated, setUserAuthenticated, setUserMenssageApi);
                });
        }
    };

    const value = useMemo(() => ({
        praca,
        doPraca,
    }), [praca]);
    return (
        <PracaContext.Provider
            value={ value }
        >
            {children}
        </PracaContext.Provider>
    );
}
PracaProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
export default PracaProvider;